export default {"src":"/_next/static/media/0x6b175474e89094c44da98b954eedeac495271d0f.ccfaf818.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};